<nz-modal
  nzWrapClassName="form-modal2"
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}"
  (nzOnCancel)="onEmitCloseModal(false)">
  <ng-template #modalTitle>
    <div class="container-steps-modal" [@fadeInAnimation]>
      <h2 class="text-title-md-bold title-modal">Experto</h2>
      <p class="text-info mt-xxs">Selecciona al experto</p>
    </div>
  </ng-template>

  <ng-template #modalContent>
    <div class="mb-lg">
      <input type="text" nz-input placeholder="Buscar experto por nombre o correo electrónico" (keyup)="onSearch($event)" />
    </div>

    <div class="container-modal" [@fadeInAnimation]>
      <div nz-row [nzGutter]="16" *ngIf="(experts$ | async) && (experts$ | async)?.length> 0">
        <div class="mb-sm" nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="8" nzXXl="6" *ngFor="let expert of (experts$ | async)">
          <app-card-expert class="tw-w-full" [setGrayCard]="true" [expert]="expert" (click)="onSelectExpert(expert)" [active]="selectedExpert?._id ===
            expert._id"></app-card-expert>
        </div>
      </div>
      <div nz-row [nzGutter]="16" *ngIf="(experts$ | async) && (experts$ | async)?.length === 0 && search === ''">
        <p>No hay más expertos por agregar.</p>
      </div>
      <div nz-row [nzGutter]="16" *ngIf="(experts$ | async) && (experts$ | async)?.length === 0 && search">
        <p>No hay coincidencias de búsqueda.</p>
      </div>
      <app-paginator *ngIf="(experts$ | async) && (experts$ | async)?.length> 0" class="pl-xxs" [configuration]="paginatorConfig" [total]="total$ |
        async" [index]="indexPage" (change)="onChangePagination($event)"></app-paginator>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <div class="container-footer-modal" [@fadeInAnimation]>
      <button
        style="margin-right: 5px;"
        (click)="onEmitCloseModal(false)"
        nz-button nzType="cancel">
        <i nz-icon nzType="close-circle" nzTheme="outline"></i>
        CANCELAR
      </button>
      <button
        (click)="onEmitCloseModal(true)"
        [disabled]="disableAddExpert"
        nz-button nzType="primary">
        <i nz-icon nzType="check-circle" nzTheme="outline"></i>
        ACEPTAR</button>
    </div>
  </ng-template>
</nz-modal>
